import { declineButtonLabel } from './calendarBarUtils.locstring.json';
import { acceptedButtonLabel, tentativeButtonLabel } from '../strings.locstring.json';
import loc from 'owa-localize';
import {
    canDeleteAsAttendee,
    canDeleteAsNonOrganizerAppointment,
    canDeleteAsOrganizer,
} from 'owa-calendar-event-capabilities';
import ResponseTypeType from 'owa-service/lib/contract/ResponseTypeType';

import { CalendarEvent } from 'owa-calendar-types';
import { ControlIcons } from 'owa-control-icons';
import { isBirthdayEvent } from 'owa-calendar-event-capabilities';

/**
 * Returns if the delete button should be shown to user
 * @param item
 * @param isFullForm
 */
export const canShowDeleteButton = (item: CalendarEvent, isFullForm: boolean): boolean =>
    canDeleteAsOrganizer(item) ||
    (canDeleteAsAttendee(item) && isFullForm) ||
    isBirthdayEvent(item) ||
    canDeleteAsNonOrganizerAppointment(item);

/**
 * Returns the display string for response button caption
 * @param responseType
 */
export const getCaptionFromItemResponseType = (responseType: ResponseTypeType) =>
    responseType === 'Accept'
        ? loc(acceptedButtonLabel)
        : responseType === 'Tentative'
        ? loc(tentativeButtonLabel)
        : loc(declineButtonLabel);

export const getIconFromItemResponseType = (responseType: ResponseTypeType) =>
    responseType === 'Accept'
        ? ControlIcons.Accept
        : responseType === 'Tentative'
        ? ControlIcons.Help
        : ControlIcons.Cancel;

/**
 * Returns if this event has been responded to (either by us or delegate)
 * @param item
 */
export const hasResponded = (item: CalendarEvent): boolean => {
    return (
        !item.IsOrganizer &&
        !item.IsCancelled &&
        item.AppointmentReplyTime &&
        ['Accept', 'Tentative', 'Decline'].includes(item.ResponseType)
    );
};
